import { Component, EventEmitter, Output } from '@angular/core';
import {
	INTERACTION_TYPE,
	ITEM_TYPE,
	SCOPE_TYPE,
	SUBSCOPE_TYPE,
} from 'app/interfaces/actiontracker.interface';
import { ActionTrackerService } from 'app/services/actiontracker.service';

@Component({
	selector: 'contact-promptuaries-filter',
	templateUrl: './contact-promptuaries-filter.component.html',
	styleUrls: ['./contact-promptuaries-filter.component.scss'],
})
export class ContactFilterPromptuariesComponent {
	@Output() onSelectOption = new EventEmitter();
	constructor(private atService: ActionTrackerService) {}

	selected = null;

	changeSelectedOption(option) {
		if (option) {
			this.atService.eventTracker(
				SCOPE_TYPE.Contact,
				SUBSCOPE_TYPE.Profile,
				ITEM_TYPE.PromptuariesFilter,
				INTERACTION_TYPE.Click,
				{
					selected: option,
				}
			);
		}
		this.selected = option;
		this.onSelectOption.emit(option);
	}
}
